// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* —— Shared packages drawer (patient + appointment) —— */
.appointment-packages-drawer.ant-drawer .ant-drawer-content-wrapper {
  width: 640px !important;
  max-width: calc(100vw - 24px);
}

.appointment-packages-drawer .ant-drawer-header {
  display: none;
}

.appointment-packages-drawer .ant-drawer-body {
  padding: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
}

.appointment-packages-drawer__shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.appointment-packages-drawer__header {
  flex-shrink: 0;
  padding: 20px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
}

.appointment-packages-drawer__title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.appointment-packages-drawer__title-block {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}

.appointment-packages-drawer__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0F172A;
  line-height: 1.25;
}

.appointment-packages-drawer__badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.appointment-packages-drawer__subtitle {
  margin: 6px 0 0;
  padding-inline-start: 30px;
  font-size: 12px;
  line-height: 16px;
  color: #64748B;
}

.appointment-packages-drawer__subtitle-em {
  font-weight: 500;
  color: #0F172A;
}

.appointment-packages-drawer__mode-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 16px;
  padding: 4px;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  background: #F1F5F9;
}

.appointment-packages-drawer__mode-tab {
  box-sizing: border-box;
  flex: 1 1 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  height: 36px;
  padding: 0 10px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease,
    box-shadow 0.12s ease;
}

.appointment-packages-drawer__mode-tab:hover {
  color: #0F172A;
}

.appointment-packages-drawer__mode-tab.is-active {
  background: #ffffff;
  border-color: #E2E8F0;
  color: #0EA5E9;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.appointment-packages-drawer__mode-tab .anticon {
  font-size: 14px;
  color: inherit;
}

.appointment-packages-drawer__mode-count {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 7px;
  border-radius: 9999px;
  background: #E2E8F0;
  color: #475569;
  font-size: 11px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.appointment-packages-drawer__mode-tab.is-active .appointment-packages-drawer__mode-count {
  background: #E0F2FE;
  color: #0284C7;
}

.appointment-packages-drawer__mode-auto {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 6px;
  border-radius: 4px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.appointment-packages-drawer__switch-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  background: #F8FAFC;
}

.appointment-packages-drawer__switch-copy {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.appointment-packages-drawer__switch-copy > .anticon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #F0F9FF;
  color: #0284C7;
  flex-shrink: 0;
}

.appointment-packages-drawer__switch-title {
  font-size: 12px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.35;
}

.appointment-packages-drawer__switch-sub {
  margin-top: 2px;
  font-size: 11px;
  color: #64748B;
  line-height: 1.35;
}

.appointment-packages-drawer__switch-btn {
  box-sizing: border-box;
  flex-shrink: 0;
  height: 30px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #BAE6FD;
  background: #ffffff;
  color: #0284C7;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.appointment-packages-drawer__switch-btn:hover {
  background: #F0F9FF;
}

.appointment-packages-drawer__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #64748B;
  cursor: pointer;
  flex-shrink: 0;
}

.appointment-packages-drawer__icon-btn:hover {
  background: #F1F5F9;
  color: #0F172A;
}

[dir='rtl'] .appointment-packages-drawer__title-block > .appointment-packages-drawer__icon-btn .anticon {
  transform: scaleX(-1);
}

.appointment-packages-drawer__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 20px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.appointment-packages-drawer__toolbar {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.appointment-packages-drawer__search {
  position: relative;
}

.appointment-packages-drawer__search-icon {
  position: absolute;
  inset-inline-start: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94A3B8;
  font-size: 14px;
  pointer-events: none;
}

.appointment-packages-drawer__search-input {
  box-sizing: border-box;
  width: 100%;
  height: 36px;
  padding: 0 12px;
  padding-inline-start: 36px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: rgba(248, 250, 252, 0.7);
  font-size: 12px;
  font-family: inherit;
  color: #0F172A;
  outline: none;
  transition: border-color 0.12s ease, background 0.12s ease, box-shadow 0.12s ease;
}

.appointment-packages-drawer__search-input::placeholder {
  color: #94A3B8;
}

.appointment-packages-drawer__search-input:focus {
  background: #ffffff;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 1px #0EA5E9;
}

.appointment-packages-drawer__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.appointment-packages-drawer__filter {
  box-sizing: border-box;
  height: 28px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  color: #64748B;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.appointment-packages-drawer__filter:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.appointment-packages-drawer__filter.is-active {
  background: #E0F2FE;
  border-color: #BAE6FD;
  color: #0284C7;
  font-weight: 600;
}

.appointment-packages-drawer__list-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.appointment-packages-drawer__section-label {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748B;
}

.appointment-packages-drawer__selected-count {
  font-size: 11px;
  color: #94A3B8;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.appointment-packages-drawer__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.appointment-packages-drawer__card {
  box-sizing: border-box;
  width: 100%;
  text-align: start;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  cursor: pointer;
  font-family: inherit;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.12s ease, background 0.12s ease;
}

.appointment-packages-drawer__card:hover:not(:disabled):not(.is-redeemed) {
  border-color: #CBD5E1;
}

.appointment-packages-drawer__card.is-selected {
  border: 2px solid #0EA5E9;
  background: #F0F9FF;
  padding: 15px;
}

.appointment-packages-drawer__card.is-redeemed {
  opacity: 0.75;
  cursor: not-allowed;
  background: rgba(248, 250, 252, 0.7);
}

.appointment-packages-drawer__card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.appointment-packages-drawer__card-main {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.appointment-packages-drawer__select-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-top: 2px;
  color: #CBD5E1;
  font-size: 18px;
  flex-shrink: 0;
}

.appointment-packages-drawer__select-icon.is-on {
  color: #0EA5E9;
}

.appointment-packages-drawer__select-icon.is-blocked {
  color: #CBD5E1;
  font-size: 16px;
}

.appointment-packages-drawer__radio {
  width: 18px;
  height: 18px;
  border-radius: 9999px;
  border: 1.5px solid #CBD5E1;
  display: block;
}

.appointment-packages-drawer__card-content {
  min-width: 0;
}

.appointment-packages-drawer__card-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.appointment-packages-drawer__card-name {
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.35;
}

.appointment-packages-drawer__card.is-redeemed .appointment-packages-drawer__card-name {
  font-weight: 500;
  color: #64748B;
}

.appointment-packages-drawer__code {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 4px;
  background: #F1F5F9;
  color: #475569;
  font-size: 11px;
  font-weight: 500;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
}

.appointment-packages-drawer__code--res {
  background: #E0F2FE;
  color: #0284C7;
}

.appointment-packages-drawer__card.is-selected .appointment-packages-drawer__code--res {
  background: #E0F2FE;
  color: #0284C7;
}

.appointment-packages-drawer__card.is-redeemed .appointment-packages-drawer__code {
  background: rgba(226, 232, 240, 0.6);
  color: #94A3B8;
}

.appointment-packages-drawer__card-desc {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #64748B;
}

.appointment-packages-drawer__card.is-redeemed .appointment-packages-drawer__card-desc {
  color: #94A3B8;
}

.appointment-packages-drawer__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 8px;
  border-radius: 9999px;
  background: #ECFDF5;
  color: #059669;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.appointment-packages-drawer__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #10B981;
}

.appointment-packages-drawer__chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.appointment-packages-drawer__chip.is-muted {
  background: rgba(226, 232, 240, 0.8);
  color: #64748B;
}

.appointment-packages-drawer__card-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #F1F5F9;
  font-size: 12px;
}

.appointment-packages-drawer__card.is-selected .appointment-packages-drawer__card-foot {
  border-top-color: #BAE6FD;
}

.appointment-packages-drawer__remaining {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #64748B;
  min-width: 0;
}

.appointment-packages-drawer__card.is-selected .appointment-packages-drawer__remaining {
  color: #0369A1;
  font-weight: 500;
}

.appointment-packages-drawer__card.is-redeemed .appointment-packages-drawer__remaining {
  color: #94A3B8;
}

.appointment-packages-drawer__price-block {
  text-align: end;
  flex-shrink: 0;
}

.appointment-packages-drawer__price-label {
  display: block;
  font-size: 11px;
  font-weight: 400;
  color: #64748B;
  line-height: 1.2;
}

.appointment-packages-drawer__price {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #0F172A;
  white-space: nowrap;
}

.appointment-packages-drawer__card.is-redeemed .appointment-packages-drawer__price {
  font-weight: 500;
  color: #94A3B8;
}

.appointment-packages-drawer__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 120px;
  padding: 24px;
  text-align: center;
  color: #94A3B8;
  font-size: 13px;
  font-weight: 500;
}

.appointment-packages-drawer__empty p {
  margin: 0;
}

.appointment-packages-drawer__filters--pills {
  gap: 6px;
}

.appointment-packages-drawer__pill {
  box-sizing: border-box;
  height: 28px;
  padding: 0 10px;
  border-radius: 9999px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  color: #64748B;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.appointment-packages-drawer__pill:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.appointment-packages-drawer__pill.is-active {
  background: #0EA5E9;
  border-color: #0EA5E9;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);
}

.appointment-packages-drawer__catalog {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.appointment-packages-drawer__catalog-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.appointment-packages-drawer__catalog-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #0F172A;
}

.appointment-packages-drawer__catalog-active {
  font-size: 11px;
  font-weight: 400;
  color: #0284C7;
}

.appointment-packages-drawer__catalog .appointment-packages-drawer__search-input {
  padding-inline-end: 36px;
}

.appointment-packages-drawer__search-clear {
  position: absolute;
  inset-inline-end: 6px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
}

.appointment-packages-drawer__search-clear:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.appointment-packages-drawer__expanded-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.appointment-packages-drawer__reserve-panel {
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow: hidden;
}

.appointment-packages-drawer__reserve-panel.is-active {
  border-color: #7DD3FC;
  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.15);
}

.appointment-packages-drawer__reserve-banner {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px;
  border-bottom: 1px solid #E2E8F0;
  background: #F8FAFC;
}

.appointment-packages-drawer__reserve-banner-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.appointment-packages-drawer__reserve-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.appointment-packages-drawer__reserve-title {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.35;
}

.appointment-packages-drawer__status-dot--sky {
  background: #0EA5E9;
}

.appointment-packages-drawer__tariff-chip {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 9999px;
  border: 1px solid #BFDBFE;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  flex-shrink: 0;
}

.appointment-packages-drawer__tariffs {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.appointment-packages-drawer__tariff-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.appointment-packages-drawer__tariff {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
}

.appointment-packages-drawer__tariff.is-selected {
  border: 2px solid #0EA5E9;
  background: #F0F9FF;
  padding: 9px 11px;
}

.appointment-packages-drawer__tariff-main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.appointment-packages-drawer__tariff-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.appointment-packages-drawer__tariff-name {
  font-size: 12px;
  font-weight: 600;
  color: #0F172A;
}

.appointment-packages-drawer__tariff.is-selected .appointment-packages-drawer__tariff-name {
  font-weight: 700;
}

.appointment-packages-drawer__tariff-badge {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 6px;
  border-radius: 9999px;
  border: 1px solid #E2E8F0;
  background: #F1F5F9;
  color: #475569;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.appointment-packages-drawer__tariff-badge.is-promo {
  border-color: #FDE68A;
  background: #FFFBEB;
  color: #D97706;
}

.appointment-packages-drawer__tariff-sub {
  font-size: 11px;
  color: #64748B;
  line-height: 1.35;
}

.appointment-packages-drawer__tariff-aside {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
}

.appointment-packages-drawer__tariff-price {
  font-size: 12px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #0F172A;
  white-space: nowrap;
  text-align: end;
  min-width: 4.5rem;
}

.appointment-packages-drawer__tariff-price.is-selected {
  color: #0284C7;
}

.appointment-packages-drawer__tariff-btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  white-space: nowrap;
}

.appointment-packages-drawer__tariff-btn.is-selected {
  border-color: #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);
}

.appointment-packages-drawer__allocation {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 14px;
  border-radius: 12px;
  border: 1px solid #BFDBFE;
  background: #EFF6FF;
  color: #1E40AF;
  font-size: 12px;
  line-height: 1.45;
}

.appointment-packages-drawer__allocation > .anticon {
  margin-top: 2px;
  color: #0284C7;
  font-size: 16px;
  flex-shrink: 0;
}

.appointment-packages-drawer__allocation-em {
  font-weight: 600;
  color: #1E3A8A;
}

.appointment-packages-drawer__footer {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px 12px;
  padding: 16px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
}

.appointment-packages-drawer__footer-summary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 auto;
  min-width: max-content;
  margin-inline-end: auto;
  font-size: 12px;
  white-space: nowrap;
}

.appointment-packages-drawer__footer-summary:empty {
  display: none;
}

.appointment-packages-drawer__footer-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
}

.appointment-packages-drawer__footer-price {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #0F172A;
}

.appointment-packages-drawer__footer-tier {
  font-size: 10px;
  color: #64748B;
  white-space: nowrap;
}

.appointment-packages-drawer__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, color 0.12s ease;
}

.appointment-packages-drawer__btn--ghost {
  border: 0;
  background: transparent;
  color: #475569;
}

.appointment-packages-drawer__btn--ghost:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.appointment-packages-drawer__btn--primary {
  border: 0;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.appointment-packages-drawer__btn--primary:hover:not(:disabled) {
  background: #0284C7;
}

.appointment-packages-drawer__btn--primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/drawers/PackagesDrawer/style.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB;yBACuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,6EAA6E;AAC/E;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,iFAAiF;AACnF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,4CAA4C;EAC5C,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6EAA6E;EAC7E,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,6EAA6E;EAC7E,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["/* —— Shared packages drawer (patient + appointment) —— */\n.appointment-packages-drawer.ant-drawer .ant-drawer-content-wrapper {\n  width: 640px !important;\n  max-width: calc(100vw - 24px);\n}\n\n.appointment-packages-drawer .ant-drawer-header {\n  display: none;\n}\n\n.appointment-packages-drawer .ant-drawer-body {\n  padding: 0 !important;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.appointment-packages-drawer__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.appointment-packages-drawer__header {\n  flex-shrink: 0;\n  padding: 20px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.appointment-packages-drawer__title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.appointment-packages-drawer__title-block {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.appointment-packages-drawer__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.appointment-packages-drawer__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.appointment-packages-drawer__subtitle {\n  margin: 6px 0 0;\n  padding-inline-start: 30px;\n  font-size: 12px;\n  line-height: 16px;\n  color: #64748B;\n}\n\n.appointment-packages-drawer__subtitle-em {\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.appointment-packages-drawer__mode-tabs {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 16px;\n  padding: 4px;\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n  background: #F1F5F9;\n}\n\n.appointment-packages-drawer__mode-tab {\n  box-sizing: border-box;\n  flex: 1 1 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 0;\n  height: 36px;\n  padding: 0 10px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease,\n    box-shadow 0.12s ease;\n}\n\n.appointment-packages-drawer__mode-tab:hover {\n  color: #0F172A;\n}\n\n.appointment-packages-drawer__mode-tab.is-active {\n  background: #ffffff;\n  border-color: #E2E8F0;\n  color: #0EA5E9;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.appointment-packages-drawer__mode-tab .anticon {\n  font-size: 14px;\n  color: inherit;\n}\n\n.appointment-packages-drawer__mode-count {\n  display: inline-flex;\n  align-items: center;\n  height: 18px;\n  padding: 0 7px;\n  border-radius: 9999px;\n  background: #E2E8F0;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n}\n\n.appointment-packages-drawer__mode-tab.is-active .appointment-packages-drawer__mode-count {\n  background: #E0F2FE;\n  color: #0284C7;\n}\n\n.appointment-packages-drawer__mode-auto {\n  display: inline-flex;\n  align-items: center;\n  height: 18px;\n  padding: 0 6px;\n  border-radius: 4px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.appointment-packages-drawer__switch-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 12px;\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  background: #F8FAFC;\n}\n\n.appointment-packages-drawer__switch-copy {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n}\n\n.appointment-packages-drawer__switch-copy > .anticon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: #F0F9FF;\n  color: #0284C7;\n  flex-shrink: 0;\n}\n\n.appointment-packages-drawer__switch-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.35;\n}\n\n.appointment-packages-drawer__switch-sub {\n  margin-top: 2px;\n  font-size: 11px;\n  color: #64748B;\n  line-height: 1.35;\n}\n\n.appointment-packages-drawer__switch-btn {\n  box-sizing: border-box;\n  flex-shrink: 0;\n  height: 30px;\n  padding: 0 10px;\n  border-radius: 8px;\n  border: 1px solid #BAE6FD;\n  background: #ffffff;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.appointment-packages-drawer__switch-btn:hover {\n  background: #F0F9FF;\n}\n\n.appointment-packages-drawer__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748B;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.appointment-packages-drawer__icon-btn:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n[dir='rtl'] .appointment-packages-drawer__title-block > .appointment-packages-drawer__icon-btn .anticon {\n  transform: scaleX(-1);\n}\n\n.appointment-packages-drawer__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px;\n  background: #ffffff;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.appointment-packages-drawer__toolbar {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.appointment-packages-drawer__search {\n  position: relative;\n}\n\n.appointment-packages-drawer__search-icon {\n  position: absolute;\n  inset-inline-start: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94A3B8;\n  font-size: 14px;\n  pointer-events: none;\n}\n\n.appointment-packages-drawer__search-input {\n  box-sizing: border-box;\n  width: 100%;\n  height: 36px;\n  padding: 0 12px;\n  padding-inline-start: 36px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: rgba(248, 250, 252, 0.7);\n  font-size: 12px;\n  font-family: inherit;\n  color: #0F172A;\n  outline: none;\n  transition: border-color 0.12s ease, background 0.12s ease, box-shadow 0.12s ease;\n}\n\n.appointment-packages-drawer__search-input::placeholder {\n  color: #94A3B8;\n}\n\n.appointment-packages-drawer__search-input:focus {\n  background: #ffffff;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 1px #0EA5E9;\n}\n\n.appointment-packages-drawer__filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.appointment-packages-drawer__filter {\n  box-sizing: border-box;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  color: #64748B;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.appointment-packages-drawer__filter:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.appointment-packages-drawer__filter.is-active {\n  background: #E0F2FE;\n  border-color: #BAE6FD;\n  color: #0284C7;\n  font-weight: 600;\n}\n\n.appointment-packages-drawer__list-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.appointment-packages-drawer__section-label {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.appointment-packages-drawer__selected-count {\n  font-size: 11px;\n  color: #94A3B8;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.appointment-packages-drawer__list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.appointment-packages-drawer__card {\n  box-sizing: border-box;\n  width: 100%;\n  text-align: start;\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  cursor: pointer;\n  font-family: inherit;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: border-color 0.12s ease, background 0.12s ease;\n}\n\n.appointment-packages-drawer__card:hover:not(:disabled):not(.is-redeemed) {\n  border-color: #CBD5E1;\n}\n\n.appointment-packages-drawer__card.is-selected {\n  border: 2px solid #0EA5E9;\n  background: #F0F9FF;\n  padding: 15px;\n}\n\n.appointment-packages-drawer__card.is-redeemed {\n  opacity: 0.75;\n  cursor: not-allowed;\n  background: rgba(248, 250, 252, 0.7);\n}\n\n.appointment-packages-drawer__card-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.appointment-packages-drawer__card-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.appointment-packages-drawer__select-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-top: 2px;\n  color: #CBD5E1;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.appointment-packages-drawer__select-icon.is-on {\n  color: #0EA5E9;\n}\n\n.appointment-packages-drawer__select-icon.is-blocked {\n  color: #CBD5E1;\n  font-size: 16px;\n}\n\n.appointment-packages-drawer__radio {\n  width: 18px;\n  height: 18px;\n  border-radius: 9999px;\n  border: 1.5px solid #CBD5E1;\n  display: block;\n}\n\n.appointment-packages-drawer__card-content {\n  min-width: 0;\n}\n\n.appointment-packages-drawer__card-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.appointment-packages-drawer__card-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.35;\n}\n\n.appointment-packages-drawer__card.is-redeemed .appointment-packages-drawer__card-name {\n  font-weight: 500;\n  color: #64748B;\n}\n\n.appointment-packages-drawer__code {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 4px;\n  background: #F1F5F9;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 500;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n}\n\n.appointment-packages-drawer__code--res {\n  background: #E0F2FE;\n  color: #0284C7;\n}\n\n.appointment-packages-drawer__card.is-selected .appointment-packages-drawer__code--res {\n  background: #E0F2FE;\n  color: #0284C7;\n}\n\n.appointment-packages-drawer__card.is-redeemed .appointment-packages-drawer__code {\n  background: rgba(226, 232, 240, 0.6);\n  color: #94A3B8;\n}\n\n.appointment-packages-drawer__card-desc {\n  margin: 4px 0 0;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #64748B;\n}\n\n.appointment-packages-drawer__card.is-redeemed .appointment-packages-drawer__card-desc {\n  color: #94A3B8;\n}\n\n.appointment-packages-drawer__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  background: #ECFDF5;\n  color: #059669;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.appointment-packages-drawer__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: #10B981;\n}\n\n.appointment-packages-drawer__chip {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.appointment-packages-drawer__chip.is-muted {\n  background: rgba(226, 232, 240, 0.8);\n  color: #64748B;\n}\n\n.appointment-packages-drawer__card-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #F1F5F9;\n  font-size: 12px;\n}\n\n.appointment-packages-drawer__card.is-selected .appointment-packages-drawer__card-foot {\n  border-top-color: #BAE6FD;\n}\n\n.appointment-packages-drawer__remaining {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: #64748B;\n  min-width: 0;\n}\n\n.appointment-packages-drawer__card.is-selected .appointment-packages-drawer__remaining {\n  color: #0369A1;\n  font-weight: 500;\n}\n\n.appointment-packages-drawer__card.is-redeemed .appointment-packages-drawer__remaining {\n  color: #94A3B8;\n}\n\n.appointment-packages-drawer__price-block {\n  text-align: end;\n  flex-shrink: 0;\n}\n\n.appointment-packages-drawer__price-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 400;\n  color: #64748B;\n  line-height: 1.2;\n}\n\n.appointment-packages-drawer__price {\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: #0F172A;\n  white-space: nowrap;\n}\n\n.appointment-packages-drawer__card.is-redeemed .appointment-packages-drawer__price {\n  font-weight: 500;\n  color: #94A3B8;\n}\n\n.appointment-packages-drawer__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 120px;\n  padding: 24px;\n  text-align: center;\n  color: #94A3B8;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.appointment-packages-drawer__empty p {\n  margin: 0;\n}\n\n.appointment-packages-drawer__filters--pills {\n  gap: 6px;\n}\n\n.appointment-packages-drawer__pill {\n  box-sizing: border-box;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  color: #64748B;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.appointment-packages-drawer__pill:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.appointment-packages-drawer__pill.is-active {\n  background: #0EA5E9;\n  border-color: #0EA5E9;\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);\n}\n\n.appointment-packages-drawer__catalog {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.appointment-packages-drawer__catalog-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.appointment-packages-drawer__catalog-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.appointment-packages-drawer__catalog-active {\n  font-size: 11px;\n  font-weight: 400;\n  color: #0284C7;\n}\n\n.appointment-packages-drawer__catalog .appointment-packages-drawer__search-input {\n  padding-inline-end: 36px;\n}\n\n.appointment-packages-drawer__search-clear {\n  position: absolute;\n  inset-inline-end: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #94A3B8;\n  cursor: pointer;\n}\n\n.appointment-packages-drawer__search-clear:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.appointment-packages-drawer__expanded-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.appointment-packages-drawer__reserve-panel {\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n}\n\n.appointment-packages-drawer__reserve-panel.is-active {\n  border-color: #7DD3FC;\n  box-shadow: 0 0 0 1px rgba(14, 165, 233, 0.15);\n}\n\n.appointment-packages-drawer__reserve-banner {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 14px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #F8FAFC;\n}\n\n.appointment-packages-drawer__reserve-banner-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.appointment-packages-drawer__reserve-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.appointment-packages-drawer__reserve-title {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.35;\n}\n\n.appointment-packages-drawer__status-dot--sky {\n  background: #0EA5E9;\n}\n\n.appointment-packages-drawer__tariff-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  border: 1px solid #BFDBFE;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.appointment-packages-drawer__tariffs {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.appointment-packages-drawer__tariff-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.appointment-packages-drawer__tariff {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.appointment-packages-drawer__tariff.is-selected {\n  border: 2px solid #0EA5E9;\n  background: #F0F9FF;\n  padding: 9px 11px;\n}\n\n.appointment-packages-drawer__tariff-main {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.appointment-packages-drawer__tariff-name-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.appointment-packages-drawer__tariff-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n.appointment-packages-drawer__tariff.is-selected .appointment-packages-drawer__tariff-name {\n  font-weight: 700;\n}\n\n.appointment-packages-drawer__tariff-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 18px;\n  padding: 0 6px;\n  border-radius: 9999px;\n  border: 1px solid #E2E8F0;\n  background: #F1F5F9;\n  color: #475569;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.appointment-packages-drawer__tariff-badge.is-promo {\n  border-color: #FDE68A;\n  background: #FFFBEB;\n  color: #D97706;\n}\n\n.appointment-packages-drawer__tariff-sub {\n  font-size: 11px;\n  color: #64748B;\n  line-height: 1.35;\n}\n\n.appointment-packages-drawer__tariff-aside {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 0 0 auto;\n}\n\n.appointment-packages-drawer__tariff-price {\n  font-size: 12px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: #0F172A;\n  white-space: nowrap;\n  text-align: end;\n  min-width: 4.5rem;\n}\n\n.appointment-packages-drawer__tariff-price.is-selected {\n  color: #0284C7;\n}\n\n.appointment-packages-drawer__tariff-btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  white-space: nowrap;\n}\n\n.appointment-packages-drawer__tariff-btn.is-selected {\n  border-color: #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);\n}\n\n.appointment-packages-drawer__allocation {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 14px;\n  border-radius: 12px;\n  border: 1px solid #BFDBFE;\n  background: #EFF6FF;\n  color: #1E40AF;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.appointment-packages-drawer__allocation > .anticon {\n  margin-top: 2px;\n  color: #0284C7;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.appointment-packages-drawer__allocation-em {\n  font-weight: 600;\n  color: #1E3A8A;\n}\n\n.appointment-packages-drawer__footer {\n  flex-shrink: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px 12px;\n  padding: 16px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.appointment-packages-drawer__footer-summary {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1 1 auto;\n  min-width: max-content;\n  margin-inline-end: auto;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.appointment-packages-drawer__footer-summary:empty {\n  display: none;\n}\n\n.appointment-packages-drawer__footer-actions {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.appointment-packages-drawer__footer-price {\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #0F172A;\n}\n\n.appointment-packages-drawer__footer-tier {\n  font-size: 10px;\n  color: #64748B;\n  white-space: nowrap;\n}\n\n.appointment-packages-drawer__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n\n.appointment-packages-drawer__btn--ghost {\n  border: 0;\n  background: transparent;\n  color: #475569;\n}\n\n.appointment-packages-drawer__btn--ghost:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.appointment-packages-drawer__btn--primary {\n  border: 0;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.appointment-packages-drawer__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n}\n\n.appointment-packages-drawer__btn--primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
